module.exports = __webpack_public_path__ + "static/media/laptop.b2536fe0.png";